// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Continue`
};

const de_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Weiter`
};

const es_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Continuar`
};

const fr_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Continuer`
};

const fi_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Jatka`
};

const hi_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `जारी रखें`
};

const ja_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `続行`
};

const nl_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Doorgaan`
};

const pt_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Continuar`
};

const ro_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Continuă`
};

const th_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `ดำเนินการต่อ`
};

const ur_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `جاری رکھیں`
};

const zh_hant1_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `繼續`
};

const da_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Fortsæt`
};

const it_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Continua`
};

const vn_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Tiếp tục`
};

const ko_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `계속하기`
};

const tr_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Devam et`
};

const lv_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Turpināt`
};

const ar_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `متابعة`
};

const bs_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Nastavi`
};

const sl_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Nadaljuj`
};

const id_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Lanjutkan`
};

const sv_widget_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Fortsätt`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_continue = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_continue(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_continue", locale)
	if (locale === "en") return en_widget_continue(inputs)
	if (locale === "de") return de_widget_continue(inputs)
	if (locale === "es") return es_widget_continue(inputs)
	if (locale === "fr") return fr_widget_continue(inputs)
	if (locale === "fi") return fi_widget_continue(inputs)
	if (locale === "hi") return hi_widget_continue(inputs)
	if (locale === "ja") return ja_widget_continue(inputs)
	if (locale === "nl") return nl_widget_continue(inputs)
	if (locale === "pt") return pt_widget_continue(inputs)
	if (locale === "ro") return ro_widget_continue(inputs)
	if (locale === "th") return th_widget_continue(inputs)
	if (locale === "ur") return ur_widget_continue(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_continue(inputs)
	if (locale === "da") return da_widget_continue(inputs)
	if (locale === "it") return it_widget_continue(inputs)
	if (locale === "vn") return vn_widget_continue(inputs)
	if (locale === "ko") return ko_widget_continue(inputs)
	if (locale === "tr") return tr_widget_continue(inputs)
	if (locale === "lv") return lv_widget_continue(inputs)
	if (locale === "ar") return ar_widget_continue(inputs)
	if (locale === "bs") return bs_widget_continue(inputs)
	if (locale === "sl") return sl_widget_continue(inputs)
	if (locale === "id") return id_widget_continue(inputs)
	if (locale === "sv") return sv_widget_continue(inputs)
	return "widget_continue"
};